import Man2Icon from '@mui/icons-material/Man2';
import WcIcon from '@mui/icons-material/Wc';
import Woman2Icon from '@mui/icons-material/Woman2';

export const defaultLogo = './logos/logo_atomic_crm.svg';

export const defaultTitle = 'MRT Dashboard';

export const defaultCompanySectors = [
    'Communication Services',
    'Consumer Discretionary',
    'Consumer Staples',
    'Energy',
    'Financials',
    'Health Care',
    'Industrials',
    'Information Technology',
    'Materials',
    'Real Estate',
    'Utilities',
];

export const defaultDealStages = [
    { value: 'opportunity', label: 'Opportunity' },
    { value: 'proposal-sent', label: 'Proposal Sent' },
    { value: 'in-negociation', label: 'In Negotiation' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' },
    { value: 'delayed', label: 'Delayed' },
];

export const defaultDealPipelineStatuses = ['won'];

export const defaultDealCategories = [
    'Other',
    'Copywriting',
    'Print project',
    'UI Design',
    'Website design',
];

export const defaultNoteStatuses = [
    { value: 'cold', label: 'Cold', color: '#7dbde8' },
    { value: 'warm', label: 'Warm', color: '#e8cb7d' },
    { value: 'hot', label: 'Hot', color: '#e88b7d' },
    { value: 'in-contract', label: 'In Contract', color: '#a4e87d' },
];

export const defaultQuoteStatuses = [
    { value: '0', label: 'Pending', color: '#7dbde8' },
    { value: '1', label: 'Approved', color: '#2e7d32' },
    { value: '2', label: 'Rejected', color: '#e88b7d' },
    { value: '3', label: 'Pending finish quoting', color: '#f0ad4e' },
];

export const defaultTicketStatuses = [
    { value: '0', label: 'Pending', color: '#7dbde8' },
    { value: '1', label: 'Resolved', color: '#2e7d32' },
];

export const defaultLeadStatuses = [
    { value: 'pending', label: 'Pending', color: '#7dbde8' },
    { value: 'contacted', label: 'Contacted', color: '#f0ad4e' },
    { value: 'done', label: 'Done', color: '#2e7d32' },
];

/** Show/edit choices: omit done unless the record is already done (display / change-away). */
export const leadStatusEditChoices = (currentStatus?: string | null) =>
    defaultLeadStatuses.filter(
        item => item.value !== 'done' || currentStatus === 'done',
    );

export const defaultLeadNextStepStatuses = [
    { value: 'pending', label: 'Pending', color: '#7dbde8' },
    { value: 'done', label: 'Done', color: '#2e7d32' },
    { value: 'pass', label: 'Pass', color: '#9e9e9e' },
];

export const ticketStatuses = {
    pending: 0,
    resolved: 1,
};

export const quoteStatuses = {
    'pending': 0,
    'approved': 1,
    'rejected': 2,
    'pending_finish_quoting': 3,
};

export const defaultTypeOfWork: { [key: string]: string } = {
    're_roof': 'Re-roof',
    'new_construction': 'New Construction',
    'repairs': 'Repairs',
};

export const typeOfWorkSelector = Object.keys(defaultTypeOfWork).map(key => ({
    value: key,
    label: defaultTypeOfWork[key],
}));

export const projectDeckType: { [key: string]: string } = {
    'wood': 'Wood',
    'concrete': 'Concrete',
    'steel': 'Steel',
    'lightweight_concrete': 'Lightweight Concrete',
};

export const projectDeckTypeSelector = Object.keys(projectDeckType).map(key => ({
    value: key,
    label: projectDeckType[key],
}));

export const projectDocumentType: { [key: string]: string } = {
    'QUOTE': 'QUOTE',
    'PROJECT': 'PROJECT',
};

export const projectDocumentTypeSelector = Object.keys(projectDocumentType).map(key => ({
    value: key,
    label: projectDocumentType[key],
}));

export const projectDocumentExtension: { [key: string]: string } = {
    'DOCX': 'docx',
    'XLSX': 'xlsx'
};

export const projectDocumentExtensionSelector = Object.keys(projectDocumentExtension).map(key => ({
    value: key.toLocaleLowerCase(),
    label: projectDocumentExtension[key],
}));

export const projectLeadType: { [key: string]: string } = {
    'owner': 'Owner',
    'contactor': 'Contractor'
};

export const projectPermitFees: { [key: string]: string } = projectLeadType;

export const projectLeadTypeSelector = Object.keys(projectLeadType).map(key => ({
    value: key,
    label: projectLeadType[key],
}));

export const projectPermitFeesSelector = projectLeadTypeSelector;

export const roofType: { [key: string]: string } = {
    'sloped_roof': 'Sloped roof',
    'flat_roof': 'Flat roof',
    'mixed_roof': 'Mixed roof'
};

export const roofTypeSelector = Object.keys(roofType).map(key => ({
    value: key,
    label: roofType[key],
}));

export const roofingSystem: { [key: string]: { [key: string]: string } } = {
    'sloped_roof': {
        'metal': 'Metal',
        'tile': 'Tile',
        'shingle': 'Shingle',
    },
    'flat_roof': {
        'built_up_roof_bur': 'Built Up Roof Bur',
        'single_ply': 'Single Ply',
    },
    'mixed_roof': {
        'only_the_sloped_roof': 'Only The Sloped Roof',
        'only_the_flat_roof': 'Only The Flat Roof',
        'the_whole_roof': 'The Whole Roof'
    }
};

export const propertyDescriptionType: { [key: string]: string } = {
    "residential_community": 'Residential Community',
    "warehouse": 'Warehouse',
    "single_family": 'Single Family',
};

export const propertyDescriptionTypeSelector = Object.keys(propertyDescriptionType).map(key => ({
    value: key,
    label: propertyDescriptionType[key],
}));

export const defaultTaskTypes = [
    'None',
    'Email',
    'Demo',
    'Lunch',
    'Meeting',
    'Follow-up',
    'Thank you',
    'Ship',
    'Call',
];

export const defaultContactGender = [
    { value: 'male', label: 'He/Him', icon: Man2Icon },
    { value: 'female', label: 'She/Her', icon: Woman2Icon },
    { value: 'nonbinary', label: 'They/Them', icon: WcIcon },
];
